import React, { useState, useEffect } from "react";
import "./Loader.css";

import { FaRegFutbol } from "react-icons/fa";
import { MdSportsTennis, MdOutlineSportsVolleyball } from "react-icons/md";
import { BiTennisBall } from "react-icons/bi";

const icons = [
  FaRegFutbol,
  MdSportsTennis,
  BiTennisBall,
  MdOutlineSportsVolleyball,
];

export default function Loader() {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % icons.length);
    }, 500); // troca a cada 0.5s
    return () => clearInterval(interval);
  }, []);

  const Icon = icons[current];

  return (
    <div className="loader-overlay">
      <Icon className="loader-icon" />
    </div>
  );
}
